'use client';
import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LangLink } from "../../i18n/links";

function FAQItem({ item, isOpen, onToggle }) {
  const bodyRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (bodyRef.current) {
      setHeight(isOpen ? bodyRef.current.scrollHeight : 0);
    }
  }, [isOpen]);

  return (
    <div className="faq-item">
      <button
        type="button"
        className={`faq-question${isOpen ? " faq-open" : ""}`}
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span>{item.question}</span>
        <svg
          className="faq-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      <div
        className="faq-body-wrap"
        style={{ height, overflow: "hidden", transition: "height 0.28s ease" }}
      >
        <div className="faq-body" ref={bodyRef}>
          {item.answer}
        </div>
      </div>
    </div>
  );
}

function FAQAccordion({ variant = null } = {}) {
  const [openId, setOpenId] = useState("q1");
  const { t } = useTranslation(["home"]);

  const faqs = ["q1","q2","q3","q4","q5","q6","q7","q8"].map((id) => ({
    id,
    question: t(`faq.questions.${id}.question`),
    answer:   t(`faq.questions.${id}.answer`),
  }));

  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));

  if (variant === "simple") {
    return (
      <div className="faq-simple-section" style={{ marginBottom: '60px'}}>
        <div className="">
          <div className="row">
            <div className="col-lg-12 mx-auto">
              <div className="heading hbm mb-4">
                <h3>{t("faq.title")}</h3>
              </div>
              <div className="faq-list">
                {faqs.map((item) => (
                  <FAQItem
                    key={item.id}
                    item={item}
                    isOpen={openId === item.id}
                    onToggle={() => toggle(item.id)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="faq-section section-padding2">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div className="heading hbm text-center mb-5">
              <h2>{t("faq.title")}</h2>
            </div>
            <div className="faq-list">
              {faqs.map((item) => (
                <FAQItem
                  key={item.id}
                  item={item}
                  isOpen={openId === item.id}
                  onToggle={() => toggle(item.id)}
                />
              ))}
            </div>
            <div className="text-center mt-5">
              <LangLink to="/support" className="btn btn-outline-primary px-4">
                {t("faq.see_all_faqs")}
              </LangLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQAccordion;
